import { useState } from "react";
import api from "@/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Package } from "lucide-react";

export default function RestockModal({ item, open, onClose, onDone }) {
  const [qty, setQty] = useState("");
  const [supplier, setSupplier] = useState("");
  const [saving, setSaving] = useState(false);

  if (!item) return null;

  const submit = async () => {
    const n = Number(qty);
    if (!n || n < 1) { toast.error("Enter a positive quantity"); return; }
    setSaving(true);
    try {
      await api.put(`/ipd/inventory/${item.id}/restock`, {
        quantity_added: n,
        supplier: supplier || item.supplier || null,
      });
      toast.success(`Restocked ${item.item_name}`);
      setQty(""); setSupplier("");
      onDone?.();
      onClose?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent data-testid="ipd-restock-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Package className="w-4 h-4 text-sky-600" /> Restock — {item.item_name}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-3">
          <div><Label>Current stock</Label>
            <Input value={`${item.quantity} ${item.unit}`} readOnly disabled /></div>
          <div><Label>Add quantity *</Label>
            <Input type="number" value={qty} onChange={(e) => setQty(e.target.value)}
                   placeholder="e.g. 50" data-testid="ipd-restock-qty" /></div>
          <div><Label>Supplier (optional)</Label>
            <Input value={supplier} onChange={(e) => setSupplier(e.target.value)}
                   placeholder={item.supplier || "—"} /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={saving} className="bg-sky-500 hover:bg-sky-600 text-white"
                  data-testid="ipd-restock-submit">{saving ? "Restocking…" : "Restock"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
